/** Build-time API base (empty in dev → same-origin, proxied by Vite to wrangler dev). */
export const API_BASE = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');
export const STORAGE_KEY_API = 'sb.apiKey';
export const DB_NAME = 'southbay-crm';
export const DB_VERSION = 4;
export const APP_NAME = 'Orange County CRM';

/** Maps JS browser key — public by design, restricted by domain in the Google Cloud console (M2). */
export const GOOGLE_MAPS_BROWSER_KEY = 'AIzaSyAHuuBZXnW4veuUQSp_3zD87Fa9M5RrFy4';
/** Orange County (Santa Ana / Orange / Costa Mesa) — default bias for the anchor search. */
export const TERRITORY_CENTER = { lat: 33.72, lng: -117.87 };
export const ROUTE_RADIUS_M = 1000; // ~0.6 mi — dense corridor coverage (D40 reverted by owner)
